import { render, staticRenderFns } from "./create-portfolio-section-template.vue?vue&type=template&id=8a33b1bc&scoped=true&lang=pug&"
import script from "./create-portfolio-section-template.vue?vue&type=script&lang=js&"
export * from "./create-portfolio-section-template.vue?vue&type=script&lang=js&"
import style0 from "./create-portfolio-section-template.vue?vue&type=style&index=0&id=8a33b1bc&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a33b1bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardText,VCardTitle,VProgressLinear})
